import React from 'react'
import { Outlet } from 'react-router-dom'

export function NoAuth() {
  return (
    <div>
      <Outlet />
    </div>
  )
}
export default NoAuth

NoAuth.propTypes = {
}

NoAuth.defaultProps = {
}
